module.exports = __webpack_public_path__ + "img/RegFees-3-posters.c215d83c.svg";